export const COLUMNS_TABLE_ID = 62;
export const SELECTION_COMPONENT = 'select-column-alias'